var map = {
	"./clubs-1.svg": 3259,
	"./clubs-10.svg": 4412,
	"./clubs-11.svg": 485,
	"./clubs-12.svg": 9996,
	"./clubs-13.svg": 640,
	"./clubs-9.svg": 2225,
	"./diamonds-1.svg": 4469,
	"./diamonds-10.svg": 7343,
	"./diamonds-11.svg": 2997,
	"./diamonds-12.svg": 1928,
	"./diamonds-13.svg": 8599,
	"./diamonds-7.svg": 3928,
	"./diamonds-8.svg": 2446,
	"./diamonds-9.svg": 1376,
	"./hearts-1.svg": 8143,
	"./hearts-10.svg": 4691,
	"./hearts-11.svg": 3383,
	"./hearts-12.svg": 9730,
	"./hearts-13.svg": 6072,
	"./hearts-9.svg": 3375,
	"./spades-1.svg": 3416,
	"./spades-10.svg": 7549,
	"./spades-11.svg": 900,
	"./spades-12.svg": 1971,
	"./spades-13.svg": 8286,
	"./spades-9.svg": 4972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5836;